import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


import styles from './HeroSection.module.css';
import Button from '../../common/Button/Button';
import Particles from './Particles';
import { useState, useEffect } from 'react';
import pb from '../../../lib/pocketbase';

function HeroSection() {
  const slides = [
    {
      image: '/images/maison.jpg',
      title: "Maison Quinard : L'expertise du bois au service de vos rêves.",
      text: "Constructeur de maisons ossature bois, extensions et aménagements extérieurs en Occitanie.",
      effect: styles.zoomInEffect
    },
    {
      image: '/images/maison2.jpg',
      title: "Des extensions sur-mesure pour agrandir votre espace.",
      text: "L'élégance naturelle du bois alliée à une performance thermique exceptionnelle.",
      effect: styles.zoomOutEffect
    },
    {
      image: '/images/maison3.jpg',
      title: "Donnez vie à vos projets d'aménagements extérieurs.",
      text: "Terrasses, pergolas et carports conçus pour durer et embellir votre jardin.",
      effect: styles.panRightEffect
    },
    {
      image: '/images/terrasse.jpg',
      title: "L'art de vivre en bois, durable et responsable.",
      text: "Nous sélectionnons les meilleures essences pour des réalisations respectueuses de l'environnement.",
      effect: styles.panLeftEffect
    },
    {
      image: '/images/pergola.jpg',
      title: "Des pergolas et carports pour sublimer votre extérieur.",
      text: "Une protection élégante et naturelle pour profiter de votre jardin en toute saison.",
      effect: styles.panDownEffect
    },
    {
      image: '/images/extension1.jpg',
      title: "Agrandissez votre horizon avec une extension bois.",
      text: "Gagnez de la surface habitable avec une solution rapide, écologique etesthétique.",
      effect: styles.panUpEffect
    }

  ];


  const [dynamicSlides, setDynamicSlides] = useState([]);

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const records = await pb.collection('hero_slides').getFullList({
          filter: 'active = true',
          sort: 'order',
        });

        const mappedSlides = records.map(record => ({
          id: record.id,
          image: pb.files.getURL(record, record.image),
          title: record.title,
          text: record.text,
          button1_text: record.button1_text,
          button1_link: record.button1_link,
          button2_text: record.button2_text,
          button2_link: record.button2_link,
          effect: styles[record.effect] || styles.zoomInEffect
        }));

        if (mappedSlides.length > 0) {
          setDynamicSlides(mappedSlides);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des diapositives:", error);
      }
    };

    fetchSlides();
  }, []);

  const displaySlides = dynamicSlides.length > 0 ? dynamicSlides : slides;

  return (
    <section className={styles.heroContainer}>
      <Swiper
        modules={[Autoplay, EffectFade, Pagination, Navigation]}
        effect="fade"
        speed={2000}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop={true}
        pagination={{
          clickable: true,
          bulletClass: styles.paginationBullet,
          bulletActiveClass: styles.paginationBulletActive,
        }}
        navigation={true}
        className={styles.mySwiper}
      >

        {displaySlides.map((slide, index) => (
          <SwiperSlide key={slide.id || index} className={styles.swiperSlide}>
            <div
              className={`${styles.slideBg} ${slide.effect}`}
              style={{ backgroundImage: `url(${slide.image})` }}
            />

            <div className={styles.overlay} />
            <div className={styles.heroContent}>
              <h1 className={styles.animateTitle}>{slide.title}</h1>
              {slide.text && <p className={styles.animateText}>{slide.text}</p>}
              <div className={styles.heroButtons}>
                {(slide.button1_text || !dynamicSlides.length) && (
                  <Button to={slide.button1_link || "/realisations"} variant="primary">
                    {slide.button1_text || "Voir nos réalisations"}
                  </Button>
                )}
                {(slide.button2_text || !dynamicSlides.length) && (
                  <Button to={slide.button2_link || "/contact"} variant="secondary">
                    {slide.button2_text || "Demander un devis gratuit"}
                  </Button>
                )}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <Particles />
    </section>
  );
}

export default HeroSection;
